import { RpcError } from '../../../shared/error/rpc.error';
import { CompanySettings } from '../../model/company-settings';
import * as fromCompanySettingsActions from '../actions/company-settings.actions';

export interface CompanySettingsState {
  entity: CompanySettings;
  loaded: boolean;
  loading: boolean;
  saving: boolean;
  saved: boolean;
  error?: string | RpcError;
}

export const companySettingsInitialState: CompanySettingsState = {
  entity: {} as CompanySettings,
  loaded: false,
  loading: false,
  saving: false,
  saved: false,
  error: null
};

export function reducer(
  state: CompanySettingsState = companySettingsInitialState,
  action: fromCompanySettingsActions.CompanySettingsActions
): CompanySettingsState {
  switch (action.type) {
    case fromCompanySettingsActions.LOAD_COMPANY_SETTINGS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        saving: false,
        saved: false
      };
    }
    case fromCompanySettingsActions.SAVE_COMPANY_SETTINGS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        saving: true,
        saved: false
      };
    }

    case fromCompanySettingsActions.LOAD_COMPANY_SETTINGS_SUCCESS: {
      const companySettings: CompanySettings = action.payload;

      return {
        ...state,
        entity: companySettings,
        loading: false,
        loaded: true,
        saving: false,
        saved: false
      };
    }

    case fromCompanySettingsActions.SAVE_COMPANY_SETTINGS_SUCCESS: {
      const companySettings: CompanySettings = action.payload;

      return {
        ...state,
        entity: companySettings,
        loading: false,
        loaded: true,
        saving: false,
        saved: true,
        error: null
      };
    }

    case fromCompanySettingsActions.LOAD_COMPANY_SETTINGS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
        saving: false,
        saved: false
      };
    }

    case fromCompanySettingsActions.SAVE_COMPANY_SETTINGS_FAIL: {
      return {
        ...state,
        entity: action.payload.settings,
        loaded: false,
        loading: false,
        saving: false,
        saved: false,
        error: action.payload.error
      };
    }

    case fromCompanySettingsActions.REMOVE_COMPANY_SETTING_ERROR: {
      return {
        ...state,
        error: null
      };
    }
  }
  return state;
}

export const getCompanySettingsEntity: any = (
  state: CompanySettingsState
): CompanySettings => state.entity;
export const getCompanySettingsLoaded: any = (
  state: CompanySettingsState
): boolean => state.loaded;
export const getCompanySettingsLoading: any = (
  state: CompanySettingsState
): boolean => state.loading;
export const saveCompanySettingsFail: any = (
  state: CompanySettingsState
): string | RpcError => state.error;
export const getCompanySettingsSaving: any = (
  state: CompanySettingsState
): boolean => state.saving;
export const getCompanySettingsSaved: any = (
  state: CompanySettingsState
): boolean => state.saved;
export const getCompanySettingsSavedError: any = (
  state: CompanySettingsState
): string | RpcError => state.error;
